var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "out-wrap" },
    [
      _c(
        "el-container",
        { staticClass: "sen-setting-container" },
        [
          _c(
            "el-aside",
            {
              staticStyle: { padding: "0 10px 0 0" },
              attrs: { width: "280px" }
            },
            [
              _c("el-tree", {
                ref: "SlotTrees",
                attrs: {
                  data: _vm.setTree,
                  "current-node-key": _vm.currenId,
                  "default-checked-keys": [_vm.currenId],
                  props: _vm.defaultProps,
                  "expand-on-click-node": false,
                  "highlight-current": true,
                  "default-expand-all": "",
                  "node-key": _vm.nodeKey,
                  indent: 38
                },
                on: { "node-click": _vm.nodeClick },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var node = ref.node
                      var data = ref.data
                      return _c(
                        "div",
                        { staticClass: "comp-tr-node" },
                        [
                          [
                            _c("div", { staticClass: "template" }, [
                              _c(
                                "div",
                                { staticClass: "comp-tr-node--btns" },
                                [
                                  node.level == 2
                                    ? _c("el-button", {
                                        attrs: {
                                          icon: "el-icon-delete",
                                          size: "mini",
                                          circle: "",
                                          type: "danger"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.handleDel(node, data, 1)
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c("div", { staticClass: "comp-tr-node--name" }, [
                                _vm._v(" " + _vm._s(node.label) + " ")
                              ]),
                              _c(
                                "div",
                                { staticClass: "comp-tr-node--btns" },
                                [
                                  node.level == 1
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                            disabled:
                                              _vm.setTree.children &&
                                              _vm.setTree.children.length >= 100
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.handleAdd(
                                                node,
                                                data,
                                                1
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.isNewEdition
                                                ? "+ 创建词组"
                                                : "新增词库"
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  node.level == 2
                                    ? _c("el-button", {
                                        attrs: {
                                          icon: "el-icon-edit",
                                          size: "mini",
                                          circle: "",
                                          type: "info"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.handleEdit(node, data, 1)
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  node.level == 2 && !_vm.isNewEdition
                                    ? _c("el-button", {
                                        attrs: {
                                          icon: "el-icon-plus",
                                          circle: "",
                                          size: "mini",
                                          type: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleAdd(node, data, 2)
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  node.level == 3
                                    ? _c("el-button", {
                                        attrs: {
                                          icon: "el-icon-delete",
                                          size: "mini",
                                          circle: "",
                                          type: "danger"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.handleDel(node, data, 2)
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  node.level == 3
                                    ? _c("el-button", {
                                        attrs: {
                                          icon: "el-icon-edit",
                                          size: "mini",
                                          circle: "",
                                          type: "info"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.handleEdit(node, data, 2)
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ])
                          ]
                        ],
                        2
                      )
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c("div", { staticStyle: { "border-right": "1px solid #EBEEF5" } }),
          _c("el-main", { staticClass: "main-container" }, [
            _c(
              "div",
              { staticStyle: { width: "100%", height: "100%" } },
              [
                _c(
                  "div",
                  { staticClass: "main-head" },
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "primary",
                                  disabled: _vm.isNewEdition
                                    ? _vm.level == 1 ||
                                      _vm.tableData.length >= 20
                                    : _vm.level == 0 || _vm.level == 2
                                },
                                on: { click: _vm.addNewSen }
                              },
                              [
                                _vm._v(
                                  "添加新词 " +
                                    _vm._s(
                                      _vm.isNewEdition
                                        ? _vm.level == 1
                                          ? ""
                                          : _vm.tableData.length + "/20"
                                        : ""
                                    )
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function($event) {
                                    _vm.dialogVisit = true
                                  }
                                }
                              },
                              [_vm._v("导入新词")]
                            ),
                            _vm.isNewEdition
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "download-btn",
                                    on: { click: _vm.downLoadTemplate }
                                  },
                                  [
                                    _vm._v("下载导入模板"),
                                    _c("i", { staticClass: "el-icon-download" })
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        !_vm.isNewEdition
                          ? _c(
                              "el-col",
                              {
                                staticStyle: {
                                  float: "right",
                                  "margin-bottom": "5px"
                                },
                                attrs: { span: 3 }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    size: "mini",
                                    "suffix-icon": "el-icon-search",
                                    placeholder: "关键词",
                                    clearable: ""
                                  },
                                  on: {
                                    blur: _vm.onInputBlur,
                                    clear: _vm.onInputBlur
                                  },
                                  model: {
                                    value: _vm.getSensiListParams.wordName,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.getSensiListParams,
                                        "wordName",
                                        $$v
                                      )
                                    },
                                    expression: "getSensiListParams.wordName"
                                  }
                                })
                              ],
                              1
                            )
                          : _c(
                              "el-col",
                              {
                                staticStyle: {
                                  float: "right",
                                  "margin-bottom": "5px"
                                },
                                attrs: { span: 3 }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    size: "mini",
                                    "suffix-icon": "el-icon-search",
                                    placeholder: "关键词",
                                    clearable: ""
                                  },
                                  on: {
                                    blur: _vm.onInputBlur,
                                    clear: _vm.onInputBlur
                                  },
                                  model: {
                                    value: _vm.getSensiListParams.keyword,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.getSensiListParams,
                                        "keyword",
                                        $$v
                                      )
                                    },
                                    expression: "getSensiListParams.keyword"
                                  }
                                })
                              ],
                              1
                            ),
                        !_vm.isNewEdition
                          ? _c(
                              "el-col",
                              {
                                staticStyle: { float: "right" },
                                attrs: { span: 3 }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: { click: _vm.handleAsyncItem }
                                  },
                                  [_vm._v("手动同步分类词")]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      [
                        _c(
                          "el-table",
                          {
                            ref: "cusChatTable",
                            staticStyle: { "font-size": "13px" },
                            attrs: {
                              size: "small",
                              data: _vm.tableData,
                              fit: "",
                              "highlight-current-row": "",
                              align: "center",
                              "header-cell-style": { background: "#F9F9F9" },
                              height: "calc(100vh - 242px)"
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "wordName",
                                label: "关键词",
                                "min-width": "150"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "createBy",
                                label: "操作人",
                                "min-width": "150"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "createTime",
                                label: "操作时间",
                                "min-width": "150"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: { label: "操作", "min-width": "100" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      true
                                        ? _c(
                                            "el-button",
                                            {
                                              staticClass: "table-button",
                                              attrs: {
                                                type: "text",
                                                size: "small"
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.handleSenDel(
                                                    scope.$index,
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("删除")]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                !this.isNewEdition
                  ? _c("Pagination", {
                      attrs: {
                        childMsg: _vm.pageparm,
                        pageSizes: _vm.pageSizes
                      },
                      on: { callBack: _vm.callBack }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        1
      ),
      _c("AddOrEditKeyWorkType", {
        ref: "AddOrEditKeyWorkType",
        attrs: {
          typeTitle: _vm.title,
          types: _vm.types,
          ids: _vm.id,
          list: _vm.tableData,
          editType: _vm.editType,
          setTree: _vm.setTree
        },
        on: { createSuccess: _vm.createSuccess }
      }),
      _c("AddKeyWord", {
        ref: "addKeyWord",
        on: { addSuccess: _vm.addSuccess }
      }),
      _c("KeyWordImport", {
        attrs: { dialogVisiImport: _vm.dialogVisit },
        on: { dialogVisiImport: _vm.handleVisiImport }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }